export enum SubSectionSize {
  L,
  M,
}
